import { X } from 'lucide-react';
import { createPortal } from 'react-dom';

export default function Modal({ title, children, onClose }) {
  // Modal'ı document.body'ye portal'lıyoruz — aksi halde içerik
  // builder'ın <form> elemanı içine düşüp iç içe form (nested form) uyarısı oluşturuyordu.
  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div className="modal-backdrop" role="presentation" onMouseDown={onClose}>
      <section className="modal" role="dialog" aria-modal="true" aria-label={title} onMouseDown={(event) => event.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="icon-button" onClick={onClose} title="Kapat"><X /></button>
        </div>
        <div className="modal-body">{children}</div>
      </section>
    </div>,
    document.body,
  );
}